module.exports = __webpack_public_path__ + "static/reply-fe2cb32689c483c5c69f371bb2da99db.svg";